<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="oui?.mesuresConfurlConfidentialite"
	
	[label]="step1.mesuresConfurlConfidentialite"
	[type]="'text'"
	[rule]="'maxSize_200|pattern_28|required'"
	[errorMessage]="{'required' : 'ctr_131'}"
	[name]="getUid() + '_SepAtt_mesuresConfurlConfidentialite'"
>
</app-form-input>
